import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const settingMenus = (): CloudPremisePluginMenu[] => {
    return [
        {
            name: "Setup Bpm",
            key: "setupbpm",
            route: "/bpm/setup",
            privacy: "private",
        },
    ];
};

export default settingMenus;